import { fluidType } from 'Shared/common/FluidType';
import { sanitise } from 'Shared/common/Sanitise';


/* XXX THOUGHTS:

	Can subtype with eg 'drummerText' etc
	MAY be necessary to merge in fonts... 
		There is likely to be some interaction between fonts and the text sizing.
		Possibly some dependence on the smaller scale layout, and maybe even palettes too.
*/

export function standardText(sizes,fonts)  
{
	return {
		pageTitle: {
			...sanitise.heading,
			fontFamily: fonts.heading,
			fontSize: fluidType('px',sizes.endFontShrink,sizes.minDesktopWidth,40,60),
			textAlign: 'center',
			margin: '32px 0 24px 0',
		},
		teaser: {
			...sanitise.heading,
			fontSize: fluidType('px',sizes.endFontShrink,sizes.flipToMobileNav,19,25),
		},
		title: {
			...sanitise.heading,
			fontFamily: fonts.heading,
			fontSize: fluidType('px',sizes.endFontShrink,sizes.flipToMobileNav,35,45),
		},
		tagline: {
			...sanitise.heading,
			fontFamily: fonts.text
		},
		subtitle: {
			...sanitise.heading,
			fontFamily: fonts.heading,
			fontSize: fluidType('px',sizes.endFontShrink,sizes.flipToMobileNav,20,30),
		},

		paragraphTitle: {
			...sanitise.heading,
			fontFamily: fonts.text,
			fontWeight: 700,
    		margin: '2em 0 1em 0',
		    lineHeight: 1.3,
			/* A font size is needed to override the browser stylesheets for h1...h6 */
			fontSize: '1em'
		},

		plain: {
	//		fontFamily: fonts.text,    //XXX probably required? Or is 'inherit' OK?
			fontSize: 15,
		}
	}
}

